import { tinkrApiPublicFetch } from "./tinkr-api/client";
import { isIsoCountryCode } from "@tinkr/shared/countries";

/** Suggest a current location, never infer account country from browser language. */
export async function fetchProviderSignupCountryHint(): Promise<string | null> {
  try {
    const response = await fetch("/api/geo", { headers: { accept: "application/json" } });
    if (!response.ok) return null;
    const body = await response.json() as { country?: unknown };
    const code = typeof body.country === "string" ? body.country.trim().toUpperCase() : "";
    return isIsoCountryCode(code) ? code : null;
  } catch { return null; }
}

export async function fetchProviderSignupCountries(): Promise<string[]> {
  const response = await tinkrApiPublicFetch<{ ok: true; countryCodes: string[] }>(
    "/v1/provider/signup-countries"
  );
  return response.countryCodes;
}
